export const environment = {
    production: false,
    pocketBaseUrl: 'https://assets-base.beedev.in.th/',
    pocketBaseColInfoAssets: 'info_assets_dev',
    pocketBaseColInfoAssetsHistory: 'info_assets_history_dev',
};
